import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { defer, Observable, shareReplay } from 'rxjs';

export interface FieldReference {
  id: string;
  name: string;
  path: string;
  displayName?: string;
  selected?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FieldReferenceService {
  protected http = inject(HttpClient);
  private cache = new Map<string, Observable<FieldReference[]>>();

  getFieldReferences(entity: string): Observable<FieldReference[]> {
    if (!this.cache.has(entity)) {
      const request$ = defer(() => this.http.get<FieldReference[]>(`json/field-references/${entity}`)).pipe(
        shareReplay({ bufferSize: 1, refCount: false })
      );

      this.cache.set(entity, request$);
    }

    return this.cache.get(entity)!;
  }

  clearCache(entity?: string) {
    if (entity) {
      this.cache.delete(entity);
    } else {
      this.cache.clear();
    }
  }
}
